import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_ID = 'auth-user';
const OWNER_ID = 'auth-owner';
const USER_MOBILE = 'auth-mobile';
const USER_TYPE = 'auth-type';
const USER_NAME = 'auth-name';
const IS_STAFF = 'auth-isstaff';
const FACILITY_ID = 'auth-facilityId';
const FACILITY_CCY = 'auth-facilityCcy';
const FACILITY_NAME = 'auth-facilityName';
const FACILITY_PHONE_NUMBER = 'auth-facilityNumber';
const FACILITY_OFFICIAL_NAME = 'auth-facilityOfficialName';
const FACILITY_TAX_NUMBER = 'auth-facilityTaxNumber';
const CALENDAR_TIME_SLOTS = 'calendarTimeSlots';
const SHARED_WALLET = 'sharedWallet';
const PENDING_PAYMENT = 'showPendingPayment';
const FACILITY_COUNTRY_CODE = 'countryCode';
const CALENDAR_START_TIME = 'calendarStartTime';
const CALENDAR_END_TIME = 'calendarEndTime';
const LAST_SELECTED_DATE = 'lastSelectedDate';

const GLOBAL_COURTS = 'globalCourts';
const GLOBAL_BOOKING_CATEGORY = 'globalBookingCategory'
const GLOBAL_ADDONS_TABLE = 'globalAddonsTable';
const GLOBAL_COURTS_CALENDAR = 'globalCourtsCalendar';
const GLOBAL_COACHES_BY_FACILITY = "globalCoachesByFacility"
const GLOBAL_PAYMENT_METHOD = "globalPaymentMethods"
const GLOBAL_TIMING_SLOTS = "globalTimingSlots"
const GLOBAL_ADDONS = 'globalAddons';
const GLOBAL_REPORT_TYPES = 'globalReportTypes';


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() { }

  facilityIdSubject = new Subject<any>();

  isLoggedin() {
    return new Promise<any>((resolve) => {
      if (this.getToken() != null) {
        resolve(true);
      }
      else {
        resolve(false);
      }
    });
  }

  signOut(): void {
    window.sessionStorage.clear();
  }

  setToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  getFacilityId(): string | null {
    return window.sessionStorage.getItem(FACILITY_ID);
  }

  setFacilityId(facilityId: any): void {
    window.sessionStorage.removeItem(FACILITY_ID);
    window.sessionStorage.setItem(FACILITY_ID, facilityId);
    this.facilityIdSubject.next(facilityId);
  }

  getFacilityName(): string | null {
    return window.sessionStorage.getItem(FACILITY_NAME);
  }

  setFacilityName(facilityName: any): void {
    window.sessionStorage.removeItem(FACILITY_NAME);
    window.sessionStorage.setItem(FACILITY_NAME, facilityName);
  }

  getSharedWallet(): string | null {
    return window.sessionStorage.getItem(SHARED_WALLET);
  }

  setSharedWallet(SharedWallet: any): void {
    window.sessionStorage.removeItem(SHARED_WALLET);
    window.sessionStorage.setItem(SHARED_WALLET, SharedWallet);
  }

  getPendingPayment(): string | null {
    return window.sessionStorage.getItem(PENDING_PAYMENT);
  }

  setPendingPayment(PendingPayment: any): void {
    window.sessionStorage.removeItem(PENDING_PAYMENT);
    window.sessionStorage.setItem(PENDING_PAYMENT, PendingPayment);
  }

  getFacilityCountryCode(): string | null {
    return window.sessionStorage.getItem(FACILITY_COUNTRY_CODE);
  }

  setFacilityCountryCode(FacilityCountryCode: any): void {
    window.sessionStorage.removeItem(FACILITY_COUNTRY_CODE);
    window.sessionStorage.setItem(FACILITY_COUNTRY_CODE, FacilityCountryCode);
  }

  getFacilityOfficialName(): string | null {
    return window.sessionStorage.getItem(FACILITY_OFFICIAL_NAME);
  }

  setFacilityOfficialName(facilityOfficialName: any): void {
    window.sessionStorage.removeItem(FACILITY_OFFICIAL_NAME);
    window.sessionStorage.setItem(FACILITY_OFFICIAL_NAME, facilityOfficialName);
  }

  getFacilityTaxNumber(): string | null {
    return window.sessionStorage.getItem(FACILITY_TAX_NUMBER);
  }

  setFacilityTaxNumber(facilityTaxNumber: any): void {
    window.sessionStorage.removeItem(FACILITY_TAX_NUMBER);
    window.sessionStorage.setItem(FACILITY_TAX_NUMBER, facilityTaxNumber);
  }

  getCalendarTimeSlots(): string | null {
    return window.sessionStorage.getItem(CALENDAR_TIME_SLOTS);
  }

  setCalendarTimeSlots(calendarStartTime: any): void {
    window.sessionStorage.removeItem(CALENDAR_TIME_SLOTS);
    window.sessionStorage.setItem(CALENDAR_TIME_SLOTS, calendarStartTime);
  }

  getCalendarStartTime(): string | null {
    return window.sessionStorage.getItem(CALENDAR_START_TIME);
  }

  setCalendarStartTime(calendarStartTime: any): void {
    window.sessionStorage.removeItem(CALENDAR_START_TIME);
    window.sessionStorage.setItem(CALENDAR_START_TIME, calendarStartTime);
  }

  getCalendarEndTime(): string | null {
    return window.sessionStorage.getItem(CALENDAR_END_TIME);
  }

  setCalendarEndTime(calendarEndTime: any): void {
    window.sessionStorage.removeItem(CALENDAR_END_TIME);
    window.sessionStorage.setItem(CALENDAR_END_TIME, calendarEndTime);
  }

  getUserName(): string | null {
    return window.sessionStorage.getItem(USER_NAME);
  }

  setUserName(userName: any): void {
    window.sessionStorage.removeItem(USER_NAME);
    window.sessionStorage.setItem(USER_NAME, userName);
  }

  getFacilityPhoneNumber(): string | null {
    return window.sessionStorage.getItem(FACILITY_PHONE_NUMBER);
  }

  setFacilityPhoneNumber(facilityPhoneNumber: any): void {
    window.sessionStorage.removeItem(FACILITY_PHONE_NUMBER);
    window.sessionStorage.setItem(FACILITY_PHONE_NUMBER, facilityPhoneNumber);
  }

  getFacilityCcy(): string | null {
    return window.sessionStorage.getItem(FACILITY_CCY);
  }

  setFacilityCcy(ccy: any): void {
    window.sessionStorage.removeItem(FACILITY_CCY);
    window.sessionStorage.setItem(FACILITY_CCY, ccy);
  }

  setUser(user: any): void {
    window.sessionStorage.removeItem(USER_ID);
    window.sessionStorage.setItem(USER_ID, JSON.stringify(user));
  }

  getUser(): any {
    const user = window.sessionStorage.getItem(USER_ID);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }
  setOwner(owner: any): void {
    window.sessionStorage.removeItem(OWNER_ID);
    window.sessionStorage.setItem(OWNER_ID, JSON.stringify(owner));
  }

  getOwner(): any {
    const owner = window.sessionStorage.getItem(OWNER_ID);
    if (owner) {
      return JSON.parse(owner);
    }
    return {};
  }
  setMobile(mobile: string): void {
    window.sessionStorage.removeItem(USER_MOBILE);
    window.sessionStorage.setItem(USER_MOBILE, mobile);
  }
  getMobile(): string | null {
    return window.sessionStorage.getItem(USER_MOBILE);
  }

  setType(type: string): void {
    window.sessionStorage.removeItem(USER_TYPE);
    window.sessionStorage.setItem(USER_TYPE, type);
  }
  getType(): string | null {
    return window.sessionStorage.getItem(USER_TYPE);
  }

  setIsStaff(isStaff: string): void {
    window.sessionStorage.removeItem(IS_STAFF);
    window.sessionStorage.setItem(IS_STAFF, isStaff);
  }
  getIsStaff(): string | null {
    return window.sessionStorage.getItem(IS_STAFF);
  }

  getLastSelectedDate(): string | null {
    return window.sessionStorage.getItem(LAST_SELECTED_DATE);
  }

  setLastSelectedDate(date): void {
    window.sessionStorage.setItem(LAST_SELECTED_DATE, date);
  }

  removeLastSelectedDate(): void {
    window.sessionStorage.removeItem(LAST_SELECTED_DATE);
  }

  getCalenderDate = () => {
    const lastSelectedDate = this.getLastSelectedDate()
    if (!lastSelectedDate)
      return new Date(
        moment().format('YYYY-MM-DD')
      )
    return new Date(
      moment(lastSelectedDate).format('YYYY-MM-DD')
    )
  }

  setCourtsGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_COURTS, data);
  }

  getCourtsGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_COURTS);
    return JSON.parse(storedDataString);
  }

  setBookingCategoryGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_BOOKING_CATEGORY, data);
  }

  getBookingCategoryGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_BOOKING_CATEGORY);
    return JSON.parse(storedDataString);
  }


  setAddonsTableGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_ADDONS_TABLE, data);
  }

  getAddonsTableGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_ADDONS_TABLE);
    return JSON.parse(storedDataString);
  }


  setAddonsGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_ADDONS, data);
  }

  getAddonsGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_ADDONS);
    return JSON.parse(storedDataString);
  }



  setCourtsCalendarGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_COURTS_CALENDAR, data);
  }

  getCourtsCalendarGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_COURTS_CALENDAR);
    return JSON.parse(storedDataString);
  }


  setCoachesByFacilityGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_COACHES_BY_FACILITY, data);
  }

  getCoachesByFacilityGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_COACHES_BY_FACILITY);
    return JSON.parse(storedDataString);
  }


  setPaymentMethodsGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_PAYMENT_METHOD, data);
  }

  getPaymentMethodsGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_PAYMENT_METHOD);
    return JSON.parse(storedDataString);
  }

  setTimingSlotsGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_TIMING_SLOTS, data);
  }

  getTimingSlotsGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_TIMING_SLOTS);
    return JSON.parse(storedDataString);
  }

  setReportTypesGlobal(data): void {
    window.sessionStorage.setItem(GLOBAL_REPORT_TYPES, data);
  }

  getReportTypesGlobal() {
    const storedDataString = window.sessionStorage.getItem(GLOBAL_REPORT_TYPES);
    return JSON.parse(storedDataString);
  }


  removeGlobalSettings() {
    window.sessionStorage.removeItem(GLOBAL_COURTS);
    window.sessionStorage.removeItem(GLOBAL_BOOKING_CATEGORY);
    window.sessionStorage.removeItem(GLOBAL_ADDONS_TABLE);
    window.sessionStorage.removeItem(GLOBAL_COURTS_CALENDAR);
    window.sessionStorage.removeItem(GLOBAL_COACHES_BY_FACILITY);
    window.sessionStorage.removeItem(GLOBAL_PAYMENT_METHOD);
    window.sessionStorage.removeItem(GLOBAL_TIMING_SLOTS);
    window.sessionStorage.removeItem(GLOBAL_REPORT_TYPES);
  }
}

